module.exports = __webpack_public_path__ + "assets/img/math_start_head.b4923098.png";